module.exports = __webpack_public_path__ + "e75dd7d2e8a0caa5489f6f7dd03ab422.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment/social-2.jpg
// module id = ./assets/images/payment/social-2.jpg
// module chunks = 0